module.exports = __webpack_public_path__ + "img/inncash-background-2023.173e27d6.webp";